/* 列傳選單點一章時的「圖解」：交戰雙方、前情、結果與影響（只寫正史；裴注要標出處，演義不放）
 * 鍵是列傳選單上的章節 id（分幕的章寫第一幕）。格式見 src/campaign/bg/index.ts。 */
// @ts-nocheck
export default {
  'zhaoyun-1': {
    sides: [
      { f: 'shu', n: '劉備', l: '劉備、趙雲（依附劉表）', w: 1 },
      { f: 'wei', n: '曹操', l: '夏侯惇、于禁、李典' },
    ],
    before: '官渡之後，劉備投奔荊州的劉表，北上到葉縣。曹操派夏侯惇、于禁、李典來拒，兩軍在博望相持很久。裴注引《雲別傳》說，趙雲早在劉備依附袁紹時就替他暗中募兵，之後跟著到了荊州。',
    after: '劉備燒屯偽遁，夏侯惇不聽李典勸阻追了上來，中伏戰敗；李典趕來救援，劉備見好就收、散退。趙雲在這一仗生擒同鄉夏侯蘭，替他向劉備求情，薦他當軍正（裴注引《雲別傳》）。',
    src: '《三國志·蜀書·先主傳》；〈李典傳〉；〈趙雲傳〉注引《雲別傳》',
  },
  'zhaoyun-2': {
    sides: [
      { f: 'shu', n: '劉備', l: '趙雲（領桂陽太守）' },
      { f: 'han', n: '桂陽郡', l: '趙範（已投降）' },
    ],
    before: '赤壁之戰後，劉備南征武陵、長沙、桂陽、零陵四郡，四郡太守都投降了。趙雲以偏將軍領桂陽太守，接替趙範（裴注引《雲別傳》）。這中間的長坂之戰，趙雲懷抱阿斗、保護甘夫人脫險。',
    after: '趙範想把寡嫂樊氏許配給趙雲，趙雲以同姓為由堅辭，又說「範迫降耳，心未可測」。後來趙範果然逃走，趙雲沒有受到牽連（裴注引《雲別傳》）。',
    src: '《三國志·蜀書·先主傳》；〈趙雲傳〉注引《雲別傳》',
  },
  'zhaoyun-3': {
    sides: [
      { f: 'shu', n: '劉備', l: '趙雲、張飛', w: 1 },
      { f: 'wu', n: '孫權', l: '孫夫人與吳吏兵' },
    ],
    before: '劉備西入益州，留趙雲在荊州管理內事。孫夫人是孫權的妹妹，驕橫，身邊帶了很多吳國吏兵。孫權聽說劉備西征，派船來接妹妹回吳，孫夫人想把阿斗一起帶走（裴注引《雲別傳》）。',
    after: '趙雲和張飛領兵截住江面，把阿斗留了下來；孫夫人自己回了吳。《漢晉春秋》（〈二主妃子傳〉注引）說是諸葛亮派趙雲斷江留下太子。',
    src: '〈趙雲傳〉注引《雲別傳》；〈二主妃子傳〉注引《漢晉春秋》',
  },
  'zhaoyun-4': {
    sides: [
      { f: 'shu', n: '蜀漢', l: '趙雲、鄧芝（疑軍）' },
      { f: 'wei', n: '魏', l: '曹真', w: 1 },
    ],
    before: '建興六年，諸葛亮第一次北伐，揚言要從斜谷取郿，派趙雲、鄧芝當疑軍據守箕谷，自己帶主力攻祁山。魏派大將軍曹真率大軍到郿抵擋。這之前，趙雲在漢水大開營門嚇退曹軍，劉備稱他「一身都是膽」（裴注引《雲別傳》）。',
    after: '趙雲、鄧芝兵弱敵強，在箕谷失利，但收攏部眾固守，沒有大敗。街亭失守後全軍撤退，趙雲親自斷後，軍資幾乎沒丟，還把剩下的絹繳回赤岸府庫（裴注引《雲別傳》）。退軍後貶為鎮軍將軍，建興七年去世，追諡順平侯。',
    src: '《三國志·蜀書·趙雲傳》及注引《雲別傳》；〈諸葛亮傳〉',
  },
};
